var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { getObservableT } from "../Infra/i18next";
import { PatientAnalyticsEvent } from "healthex-common/analytics.dtos";
import { getHeapGlobalEventProperties } from "../Infra/LoadHeap";
const t = getObservableT("patients");
export class DocumentRetrievalReviewAndShareViewModel {
    constructor(parentModel) {
        this.parentModel = parentModel;
    }
    get locationsNeedingAuth() {
        return this.parentModel.locationsNeedingAuth;
    }
    get locationsCompleted() {
        return this.parentModel.locationsCompleted;
    }
    get organizationName() {
        return this.parentModel.organizationName;
    }
    get isStatic() {
        return this.parentModel.uiState.isStatic;
    }
    get supportingText() {
        var _a;
        return this.parentModel.isIAS
            ? this.parentModel.isHealthWalletEnabled
                ? t("Here’s a summary of the providers whose records we’ll access for your HealthEx Wallet.")
                : t("Here’s a summary of the providers whose records we’ll access for your HealthEx Unified Record.")
            : t("Your records from the following providers will be shared with {{ toolName }}.", {
                toolName: this.parentModel.isAIFlow ? this.parentModel.aiToolName : (_a = this.organizationName) !== null && _a !== void 0 ? _a : "the organization",
            });
    }
    get buttonText() {
        return this.locationsNeedingAuth.length > 0
            ? t("Continue")
            : this.parentModel.isIAS
                ? t("Access records")
                : this.parentModel.isAIFlow
                    ? t("Connect my records")
                    : t("Share my records");
    }
    get title() {
        return this.parentModel.isIAS
            ? t("Review and access your records")
            : this.parentModel.isAIFlow
                ? t("Review and connect your records")
                : t("Review and share");
    }
    async handleContinueClick() {
        var _a, _b, _c;
        this.parentModel.updateConsentLocations();
        await ((_b = (_a = this.parentModel).onRecordsShared) === null || _b === void 0 ? void 0 : _b.call(_a));
        void this.parentModel.trackFlowCompletionEvent({
            event: PatientAnalyticsEvent.PATIENT_FLOW_COMPLETED,
            identity: (_c = this.parentModel.authManager.id) !== null && _c !== void 0 ? _c : undefined,
            properties: {
                ...getHeapGlobalEventProperties(),
                completionReason: "Success",
                dataUpdateType: this.parentModel.dataUpdateType,
            },
        });
    }
}
__decorate([
    computed
], DocumentRetrievalReviewAndShareViewModel.prototype, "locationsNeedingAuth", null);
__decorate([
    computed
], DocumentRetrievalReviewAndShareViewModel.prototype, "locationsCompleted", null);
__decorate([
    computed
], DocumentRetrievalReviewAndShareViewModel.prototype, "supportingText", null);
__decorate([
    computed
], DocumentRetrievalReviewAndShareViewModel.prototype, "buttonText", null);
__decorate([
    computed
], DocumentRetrievalReviewAndShareViewModel.prototype, "title", null);
